import { render } from "./EmploymentShift.vue?vue&type=template&id=6e1071d8"
import script from "./EmploymentShift.vue?vue&type=script&lang=js"
export * from "./EmploymentShift.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__